/**
 * Created by user on 2017/12/11/011.
 */

import { zh2num, num2zh } from '@lazy-cjk/zh2num';

export {
	zh2num,
	num2zh,
}

export default {
	zh2num,
	num2zh,
}
